import React from 'react';

const TicketResult = () => {
    return (
        <div className="p-8">
            <h1 className="text-2xl font-bold">Ticket Result</h1>
            <p className="text-gray-500 mt-2">This is a placeholder for the ticket result page.</p>
        </div>
    );
};

export default TicketResult;
